module.exports = __webpack_public_path__ + "media/src/img/payment/mbank_tenge_som_qr_modal-cbf2b44ccc57659938501eef32792055.png";